import {
  columnOrderingFeature,
  columnVisibilityFeature,
  createColumnHelper,
  createExpandedRowModel,
  createPaginatedRowModel,
  createSortedRowModel,
  ReactTable,
  RowData,
  rowExpandingFeature,
  rowPaginationFeature,
  rowSortingFeature,
  sortFn_alphanumeric,
  sortFn_basic,
  sortFn_datetime,
  sortFn_text,
  tableFeatures,
  TableOptions,
  useTable,
  type ColumnVisibilityState,
} from "@tanstack/react-table";

export const rydeTableFeatures = tableFeatures({
  columnVisibilityFeature,
  columnOrderingFeature,
  rowSortingFeature,
  rowPaginationFeature,
  rowExpandingFeature,
  sortedRowModel: createSortedRowModel(),
  expandedRowModel: createExpandedRowModel(),
  paginatedRowModel: createPaginatedRowModel(),
  sortFns: {
    alphanumeric: sortFn_alphanumeric,
    basic: sortFn_basic,
    datetime: sortFn_datetime,
    text: sortFn_text,
  },
});

export type TRydeTableFeatures = typeof rydeTableFeatures;

export type {
  ColumnOrderState,
  ColumnSizingState,
  ColumnSort,
  ColumnVisibilityState,
  ExpandedState,
  ExpandedStateList,
  GroupingState,
  OnChangeFn,
  PaginationState,
  SortingState,
  Updater,
} from "@tanstack/react-table";

/** @deprecated Use `ColumnVisibilityState` — kept for v8 migration compatibility */
export type VisibilityState = ColumnVisibilityState;

export const createRydeColumnHelper = <TData extends RowData>() =>
  createColumnHelper<TRydeTableFeatures, TData>();

export type IRydeReactTable<TData extends RowData> = ReactTable<
  TRydeTableFeatures,
  TData
>;

export const useRydeTable = <TData extends RowData>(
  options: Omit<TableOptions<TRydeTableFeatures, TData>, "features">,
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
) =>
  useTable({
    features: rydeTableFeatures,
    ...options,
  });
